module.exports = __webpack_public_path__ + "static/icon-192x192-eeec1daf809efe9afb499a29857fc39d.png";